// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6653":"48ace93cb69f2233","9476":"ff803b0e32fd2310"}[chunkId] + ".css";
};